module.exports = __webpack_public_path__ + "static/media/op-logo.e147a833.svg";